module.exports = require("./ar-SY.js");